import { gql } from 'apollo-angular';

export var update_project_attributes = gql`
  mutation UPDATE_PROJECT_ATTRIBUTES($input: UpdateProjectAttributes!) {
    updateProjectAttributes(input: $input) {
      projectAttributes {
        id
        attribute {
          id
          name
          attributeType {
            id
            name
            permissions {
              _create
              _read
              _edit
              _delete
            }
          }
        }
      }
    }
  }
`;

export var add_supportive_services_included_type = gql`
  mutation ADD_SUPPORTIVE_SERVICES_INCLUDED_TYPE(
    $name: String!
    $attribute_type_id: ID!
  ) {
    addSupportiveServicesIncluded(
      name: $name
      attribute_type_id: $attribute_type_id
      is_default: false
    ) {
      id
      name
    }
  }
`;
